<template>
  <AppearFromLeft>
    <div v-if="survey_status.quotas" class="quota-container">
      <div
        v-for="(quotaGroup, index) in survey_status.quotas"
        :key="`quota-group-${index}`"
        class="quota-table"
      >
        <div class="status-row">
          <strong>{{ parseTranslation(OPTION) }}</strong>

          <div class="quota-numbers">
            <strong>{{ parseTranslation(GOAL) }}</strong>
            <strong>{{ parseTranslation(COUNT) }}</strong>
            <strong>{{ parseTranslation(DIFF) }}</strong>
          </div>
        </div>

        <hr class="divider" />

        <div class="status-row" v-for="quota in quotaGroup" :key="quota.code">
          <span>{{ quota.label }}</span>

          <div class="quota-numbers">
            <span>{{ quota.goal }}</span>
            <span>{{ quota.achieved }}</span>
            <span>{{ quota.difference }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="no-quota" v-else>
      <p>{{ parseTranslation(NO_QUOTAS) }}</p>
    </div>
  </AppearFromLeft>
</template>

<script>
import AppearFromLeft from '@/components/AppearFromLeft'

import * as translationQuota from './Quota.translations'

const { default: translations, ...translationKeys } = translationQuota

export default {
  name: 'Quota',

  components: {
    AppearFromLeft,
  },

  data() {
    return {
      translations,
      ...translationKeys,
    }
  },

  props: {
    survey_status: {
      required: true,
      type: Object,
    },
  },
}
</script>

<style lang="scss" scoped>
.no-quota {
  text-align: center;
}

.quota-table {
  border-radius: 8px;
  background: $gray-7;

  .light & {
    background: #eeeeee;
  }

  & + & {
    margin-top: 24px;
  }
}

.divider {
  /* inner padding */
  width: calc(100% - 32px);
  margin: 0 auto;
  height: 2px;
  border: none;
  background: $gray;
}

.status-row {
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: $white;

  .light & {
    color: $main;
  }

  @media (max-width: 500px) {
    flex-direction: column;
    justify-content: center;

    span {
      text-align: center;
    }
  }
}

.quota-numbers {
  @include flexAlignCenter;
  width: Max(25%, 100px);

  @media (max-width: 500px) {
    margin-top: 8px;
    width: 100%;
  }
}

.quota-numbers span,
.quota-numbers strong {
  width: 32%;
  text-align: end;

  @media (max-width: 500px) {
    text-align: center;
  }
}
</style>
